export enum InstitutionType {
    InitialBiopsy = 'INITIAL_BIOPSY',
    Institution = 'INSTITUTION',
    Physician = 'PHYSICIAN'
}

export type InstitutionAdditionalFields = 'COUNTRY'
